import { withStyles } from '@material-ui/core';
import TCell from '@material-ui/core/TableCell';
import THead from '@material-ui/core/TableHead';
import TRow from '@material-ui/core/TableRow';
import palette from 'theme/palette';

export const TableRow = withStyles({
  root: {
    height: 38,

    '&:hover': {
      cursor: 'pointer',
      opacity: 0.7,
    },

    '& svg': {
      fontSize: 14,
      fill: palette.primary.main,
    },
  },
})(TRow);

export const TableCell = withStyles({
  root: {
    padding: '0 8px',
    fontSize: 12,
  },
})(TCell);

export const TableHead = withStyles({
  root: {
    background: palette.lightGray,

    '& .MuiTableRow-root': {
      cursor: 'default',
      opacity: 1,
    },

    '& .MuiTableCell-root': {
      fontWeight: 400,
    },
  },
})(THead);
